import { createAsyncThunk } from '@reduxjs/toolkit';
import ax from 'services/apiService';
import { setTenant } from '../slices/tenantSlice';
export const userLogin = createAsyncThunk('user-login', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/login`, payload);
        if (data?.data) {
            localStorage.setItem('token', data.data.accessToken);
            localStorage.setItem('refreshToken', data.data.refreshToken);
            localStorage.setItem('expiryDate', data.data.expires);
            localStorage.setItem('appUserID',data.data?.appUserID);
        }
        localStorage.setItem('success', data.succeeded);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);  // This will trigger `rejected`
        } else {
            return rejectWithValue(error);  // For network or other errors
        }
    }
});

export const ChangePass = createAsyncThunk('change-user-password', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.put(`api/api/auth/change-password`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});

// auth/password_reset
export const SendEmail = createAsyncThunk('send-email-link', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/auth/password_reset`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// auth/reset-password/verify-token/
export const VerifyToken = createAsyncThunk('verify-the-token', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/auth/reset-password/verify-token`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});

// auth/password_reset/confirm/
export const ConfirmPassword = createAsyncThunk('confirm-the-password', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/auth/password_reset/confirm/`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// auth/password_reset/confirm/
export const getMenuService = createAsyncThunk('get-menu-the-service', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/auth/menu/menuservice`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// Auth/userinfo/id
// export const getUserDetails = createAsyncThunk('user-details-info', async (id: any, { rejectWithValue }) => {
//     try {
//         const { data } = await ax.get(`api/api/Auth/userinfo/${id}`);
//         if(data?.data){
//             // console.log("Datat",data);
            
//             localStorage.setItem('tenantID',data?.data?.tenantDetail?.tenantID);
//             localStorage.setItem('userName',data?.data?.appUser?.appuserName);
//         }
//         return data;
//     } catch (error: any) {
//         if (error.response && error.response.data) {
//             return rejectWithValue(error.response.data);
//         } else {
//             return rejectWithValue(error.response.data);
//         }
//     }
// })
export const getUserDetails = createAsyncThunk(
  'user-details-info',
  async (id: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await ax.get(`api/api/Auth/userinfo/${id}`);

      if (data?.data) {
        const tenantID = data?.data?.tenantDetail?.tenantID;
        dispatch(setTenant(tenantID));
        localStorage.setItem('tenantID', tenantID);
        localStorage.setItem('userName', data?.data?.appUser?.appuserName);
      }

      return data;
    } catch (error: any) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error);
      }
    }
  }
);